import { AxiosError } from 'axios';
import { useCallback, useState } from 'react';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { subscriptionActions } from '../../../redux/slices/subscriptionSlice';
import { SubscriptionPlan } from '../../../redux/slices/subscriptionSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useGetPlans = () => {
  const request = useHttps();
  const dispatch = useAppDisPatch();
  const [loading, setLoading] = useState(false);

  const getPlans = useCallback((subscriberType?: string) => {
    const url: HttpConfig = {
      url: 'auth-service/subscriptions/plans',
      method: 'get',
      params: subscriberType ? { subscriberType } : undefined,
    };
    return request(url, (response: unknown) => {
      const data = (response as SuccessHttpResponse<SubscriptionPlan[]>).data;
      dispatch(subscriptionActions.setPlans(data));
    }, setLoading, (err: AxiosError<ErrorHttpResponse>) => {
      console.error('Error fetching plans:', err?.message);
      dispatch(subscriptionActions.setError(err?.response?.data?.message ?? 'Failed to fetch plans'));
    });
  }, [dispatch, request]);

  return { getPlans, loading };
};

export default useGetPlans;
